import React from 'react'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { FooterSection, LeadingTitle } from '@components'
import './PolicySocialActivity.scss'
import { SocialResponsibiltiyAPI, ShortDescriptionAPI } from '@api'
import { useTranslation } from 'react-i18next'
import { TitleComponent } from '../../../common/components/TitleComponent'
import { useParams } from 'react-router-dom'
import { ThumbnailBig } from '../../../common/components'
import MenuSocial from '../MenuSocial'

const Container = styled.div`
  padding-top: 72px;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const PolicySocialActivityContainer = styled.div`
  margin-top: 56px;
  padding: 24px 119px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
    padding: 24px 30px;
  }
`

const Img = styled.img`
  width: 100%;
  height: 550px;
  object-fit: cover;
  margin: 0px auto;
  @media (max-width: 768px) {
    height: 300px;
  }
`

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`

const PolicySocialActivity = function () {
  const { t } = useTranslation()
  const [data, setdata] = useState([])
  const [shortDesc, setShortDesc] = useState({})
  const [isLoading, setisLoading] = useState(true)
  const { id } = useParams()

  useEffect(() => {
    setisLoading(true)
    loadData()
  }, [])

  const loadData = async function () {
    const { data } = await SocialResponsibiltiyAPI('/pelaksanaan')
    setdata(data.data)
    setisLoading(false)
  }
  return (
    <div>
      <TitleComponent title={shortDesc.title} />
      <Container>
        <Desktop>
          <ThumbnailBig
            title={isLoading ? '' : data.judulBannerPelaksanaan}
            desc={isLoading ? '' : data.deskripsiBannerPelaksanaa}
            img={isLoading ? '' : data.imageBannerDesktopPelaksanaan}
          />
        </Desktop>
        <Mobile>
          <ThumbnailBig
            title={isLoading ? '' : data.judulBannerPelaksanaan}
            desc={isLoading ? '' : data.deskripsiBannerPelaksanaa}
            img={isLoading ? '' : data.imageBannerMobilePelaksanaan}
          />
        </Mobile>
      </Container>

      <PolicySocialActivityContainer className="container-fluid">
        <div className="m-0 row">
          <div className="p-0 col-lg-9 col-12">
            {typeof data.BlockDataPelaksanaan != 'undefined' &&
              data.BlockDataPelaksanaan.length > 0 && (
                <div className="row">
                  {data.BlockDataPelaksanaan.map((item, index) => {
                    return (
                      <div className="col-12 mb-4">
                        <Desktop>
                          <Img src={item.imageDesktopPelaksanaan} />
                        </Desktop>
                        <Mobile>
                          <Img src={item.imageMobilePelaksanaan} />
                        </Mobile>
                        <p className="mt-4">
                          {item.tempatPelaksanaan}, {item.tanggalPelaksanaan}
                        </p>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.deskripsiPelaksanaan,
                          }}
                        ></div>
                        <hr />
                      </div>
                    )
                  })}
                </div>
              )}
          </div>
          <div className="d-none d-lg-block col">
            <MenuSocial active={1} />
          </div>
        </div>
      </PolicySocialActivityContainer>
      <FooterSection currentPage={t('PelaksanaanTanggungJawab')} />
    </div>
  )
}

export default PolicySocialActivity
